export enum ManagerContractorsSort {
  companyName = 'sort[contractor][companyName]',
  lastWeekBudgetSpent = 'sort[contractor][lastWeekBudgetSpent]',
  totalSpent = 'sort[contractor][totalSpent]',
  weeklyBudgetSpent = 'sort[contractor][weeklyBudgetSpent]',
  managerName = 'sort[manager][fullName]',
  salesRepName = 'sort[salesRepresentative][fullName]',
}

export enum ManagerContractorsFilters {
  contractor = 'filters[contractor][id]',
  contractorIdArray = 'filters[contractor][id][]',
  manager = 'filters[manager][id]',
  managerArray = 'filters[manager][id][]',
  salesRep = 'filters[salesRepresentative][id]',
  salesRepArray = 'filters[salesRepresentative][id][]',
}

export enum ContractorCampaignIntegrationsSort {
  campaignName = 'sort[campaign][name]',
  campaignId = 'sort[campaign][id]',
}
